import { RG_TYPE as i } from "@project-rouge/rg-core";
import { getArea as n } from "../index3.js";
import { getFootprint as s } from "./index21.js";
import { getGIA as c } from "./index26.js";
import { getGrossFacadeArea as p } from "./index28.js";
import { getNIA as f } from "./index38.js";
const v = (o) => {
  const r = f(o), t = c(o), e = p(o), m = n(o, [i.Roof]), a = s(o);
  return (e + a + m) / (r + 0.6 * (t - r));
};
export {
  v as getIndicativeFormFactor
};
//# sourceMappingURL=index29.js.map
